export default __webpack_public_path__ + "static/media/logo.868242d9.png";